import { render, staticRenderFns } from "./NaverPayConfigIframe.vue?vue&type=template&id=15426484&"
import script from "./NaverPayConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./NaverPayConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports